import { SiteProvider } from './context/SiteContext';
import Notice from './components/Notice';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyLearn, { StatsBar } from './components/WhyLearn';
import Audience from './components/Audience';
import Curriculum from './components/Curriculum';
import Schedule from './components/Schedule';
import Instructor from './components/Instructor';
import Offer from './components/Offer';
import EnrollForm from './components/EnrollForm';
import FAQ from './components/FAQ';
import Footer, { FinalCTA } from './components/Footer';
import StickyCTA from './components/StickyCTA';

export default function App() {
  return (
    <SiteProvider>
      <Notice />
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <WhyLearn />
        <Audience />
        <Curriculum />
        <Schedule />
        <Instructor />
        <Offer />
        <EnrollForm />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </SiteProvider>
  );
}
